import { FiEye, FiFilter, FiPieChart } from 'react-icons/fi';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

const STEPS = [
  {
    icon: FiFilter,
    title: 'Deterministic pass',
    description:
      'A fast, rule-based pass removes structured sensitive data on sight — credit card numbers, national ID/SSN-style numbers, IP addresses, phone numbers, and email addresses.',
  },
  {
    icon: FiEye,
    title: 'Contextual AI pass',
    description:
      'A contextual AI pass then reviews the remaining text and replaces real names, company names, physical addresses, and financial figures with realistic placeholders — the sentence still reads naturally.',
  },
  {
    icon: FiPieChart,
    title: 'Visible & reviewable',
    description:
      'Every message that had something filtered is marked with a visible "filtered for privacy" indicator. Review exactly how much has been filtered any time, with a month-by-month chart.',
  },
];

export default function PrivacyLayerSection() {
  return (
    <section id="privacy" className="scroll-mt-24 bg-surface py-24 dark:bg-midnight-800">
      <div className="container-page flex flex-col items-center gap-14">
        <SectionHeading
          eyebrow="How it works"
          title="Every message passes through the redaction engine first"
          description="Before the AI model ever sees your message, it goes through two layers of screening — so the assistant still understands your intent, but never sees who or what you're really talking about."
        />

        <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((step, index) => (
            <Reveal key={step.title} delay={index * 0.1} className="card relative flex flex-col gap-4 p-8">
              <span className="absolute right-6 top-6 text-4xl font-black text-line dark:text-midnight-600">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-gradient-soft text-brand-600 dark:text-brand-300">
                <step.icon size={20} />
              </span>
              <h3 className="text-lg font-bold text-ink dark:text-white">{step.title}</h3>
              <p className="text-sm leading-relaxed text-muted dark:text-subtle">{step.description}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3} className="w-full">
          <div className="card flex flex-col items-center gap-3 bg-brand-gradient-soft p-8 text-center">
            <p className="max-w-2xl text-sm leading-relaxed text-ink dark:text-white">
              <strong>Nothing is silently rewritten.</strong> Your account includes a personal redaction history with
              a month-by-month chart, and organization administrators get the same view rolled up across their
              entire team — with a one-click option to email a full report.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
